export default __webpack_public_path__ + "static/media/monkey.cb2e47c4.png";